<template>
  <div
      ref="tooltip"
      class="info-tooltip info-tooltip--dark"
      :class="{
        'info-tooltip--small': isTooltipFullyVisible,
        'cut-top': isCutOff.top,
        'cut-bottom': isCutOff.bottom,
        'cut-left': isCutOff.left,
        'cut-right': isCutOff.right
      }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const tooltip = ref<HTMLElement | null>(null)
const isCutOff = reactive({
  top: false,
  bottom: false,
  left: false,
  right: false
})

function checkTooltipCutOff() {
  if (!tooltip.value) return

  const rect = tooltip.value.getBoundingClientRect()
  isCutOff.top = rect.top < 0
  isCutOff.bottom = rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
  isCutOff.left = rect.left < 0
  isCutOff.right = rect.right > (window.innerWidth || document.documentElement.clientWidth)
}

function isTooltipFullyVisible() {
  if (!tooltip.value) return false

  const rect = tooltip.value.getBoundingClientRect()
  const isVisible = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )

  return isVisible
}



onMounted(() => {
  checkTooltipCutOff()


  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        checkTooltipCutOff()
      }
    })
  })

  if (tooltip.value) {
    observer.observe(tooltip.value, { attributes: true, attributeFilter: ['style'] })
  }
})
</script>

<style scoped lang="scss">
.info-tooltip {
  border-radius: 8px;
  max-width: 280px;
  width: 280px;
  padding: 12px;
  font-size: 12px;
  position: absolute;
  left: -136px;
  top: 24px;
  z-index: 1001;
  animation: overlaypanel-animation 0.3s ease-out;

  &--small {
    max-width: 240px;
    width: 240px;
    left: -120px;
  }

  &--dark {
    background: #292929;
    color: #fff;
    z-index: 1111;

    &::after {
      border-color: transparent transparent #292929 transparent;
    }

    :root[data-theme="dark"] & {
      background: #e2e4e9;
      color: #141418;

      &::after {
        border-color: transparent transparent #e2e4e9 transparent;
      }
    }
  }

  &::after {
    content: '';
    height: 10px;
    width: 10px;
    bottom: 100%;
    left: calc(50% - 5px);
    position: absolute;
    border-width: 8px;
    border-style: solid;
  }

  &.cut-top {
    //for check
    //border-top: 2px solid red;
  }

  &.cut-bottom {
    //for check
    //border-bottom: 2px solid red;
  }

  &.cut-left {
    left: -15px;
    &::after {
      left: 13px;
    }
  }

  &.cut-right {
    //for check
    //border-right: 2px solid red;
  }
}

@keyframes overlaypanel-animation {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>